import _ from 'lodash';
import {getSelectedProjectId} from '../reducers/project'
import {getInternalAppRoles, getExternalAppRoles} from '../reducers/administrationModal'
import {Role} from '../../models/administration'
import { getSelectedProject } from './project';
import { StakeHolder } from '../../models/stakeHolder';
import { getStakeHolders } from '../reducers/sharedData';
import { getUiRules } from '../reducers/notifySettings';
import { NotifyRule } from '../../models/notifyRule';

export const getSelectedProjectInternalAppRoles = (state: any): Role[] => {
    return getInternalAppRoles(state);
}

export const getSelectedProjectExternalAppRoles = (state: any): Role[] => {
    return getExternalAppRoles(state);
}

export const getSelectedProjectCustomerStakeholders = (state: any): StakeHolder[] => {
    const stakeholders = getStakeHolders(state);
    const customers = (stakeholders && stakeholders.length > 0 && _.some(stakeholders, s => s.isCustomer)) ? _.filter(stakeholders, s => s.isCustomer) : []
    return customers;
}


export const getAllAdminNotifications = (state: any): NotifyRule[] => {
    let notifications = _.map(getUiRules(state), r => {return {...r, eventTypeRuleId: undefined, ruleJson: undefined, msChat: true, mail: true}}) as NotifyRule[];
    return notifications;
}
